import React, { useState, useEffect } from 'react';
import { FiStar, FiArrowRight } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import config from '../../config/config';
import Popupform from '../Popupform/Popupform';
import { NavLink } from 'react-router-dom';

// Updated tabs with all missing courses
const tabs = [
    { label: "BE/B.TECH", value: "B.Tech" },
    { label: "MBA/PGDM", value: "MBA" },
    { label: "M.TECH", value: "M.Tech" },
    { label: "PH.D", value: "PH.D" },
    { label: "MBBS", value: "MBBS" },
    { label: "M.SC", value: "M.Sc" },
    { label: "BCA", value: "BCA" },
    { label: "B.SC", value: "B.Sc" },
    { label: "B.SC NURSING", value: "B.Sc Nursing" },
    { label: "BA", value: "BA" },
    { label: "B.COM", value: "B.Com" }
];

const TopCollegesSection = () => {
    const [activeTab, setActiveTab] = useState(0);
    const [colleges, setColleges] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchCollegeData = async () => {
            try {
                const response = await axios.get(`${config.API_BASE_URL}/api/admin/get_collegespage`);
                setColleges(response.data.collegePages || []);
            } catch (error) {
                console.error("Error fetching college data:", error);
            }
        };
        fetchCollegeData();
    }, []);

    const handleOpenPopup = (e) => {
        if (e) e.preventDefault();
        setShowPopup(true);
        document.body.style.overflow = "hidden";
    };

    const handleClosePopup = () => {
        setShowPopup(false);
        document.body.style.overflow = "auto";
    };

    const handleTabClick = (index, courseValue) => {
        setActiveTab(index);
        // Navigate to the course page
        navigate(`/c_pages/${courseValue}`);
    };

    return (
        <section className="py-20 bg-white">
            <div className="container mx-auto px-4">
                <div className="border-2 border-orange-200 rounded-3xl p-8 md:p-12 shadow-sm hover:shadow-md transition-shadow duration-300">
                    <div className="flex flex-col md:flex-row justify-between items-center mb-8">
                        <h2 className="text-3xl font-bold text-gray-800 mb-4 md:mb-0">Top 10 Colleges in India</h2>
                        <button className="bg-brand-orange text-white px-8 py-3 rounded-full font-semibold hover:bg-orange-700 transition shadow-lg text-sm tracking-wide">
                            View Complete List
                        </button>
                    </div>

                    {/* Tabs with hover effects */}
                    <div className="flex flex-wrap gap-3 mb-12">
                        {tabs.map((tab, index) => (
                            <button
                                key={index}
                                onClick={() => handleTabClick(index, tab.value)}
                                className={`px-6 py-2 rounded-full border text-xs font-bold transition-all duration-300 uppercase tracking-wide
                            ${activeTab === index
                                        ? 'bg-white border-brand-orange text-brand-orange shadow-md scale-105'
                                        : 'bg-white border-gray-200 text-gray-600 hover:border-brand-orange hover:text-brand-orange hover:shadow-sm hover:scale-105'}`}
                            >
                                {tab.label}
                            </button>
                        ))}
                    </div>

                    {/* Table/List */}
                    {/* Table/List */}
                    <div className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden">
                        {/* Desktop Header */}
                        <div className="hidden md:grid grid-cols-12 gap-4 p-5 border-b border-gray-100 text-xs font-bold text-gray-400 uppercase tracking-wider bg-gray-50">
                            <div className="col-span-1 text-center">Rank</div>
                            <div className="col-span-5">College & Details</div>
                            <div className="col-span-2">Ranking</div>
                            <div className="col-span-2">App Deadline</div>
                            <div className="col-span-2">Annual Fees</div>
                        </div>

                        {/* Rows */}
                        {colleges.length > 0 ? (
                            colleges.slice(0, 10).map((college, index) => (
                                <React.Fragment key={index}>
                                    {/* Mobile Card View */}
                                    <div className="md:hidden bg-white border-b border-gray-100 last:border-0 p-5 relative">
                                        {/* Rank Badge */}
                                        <div className="absolute top-0 left-0 bg-yellow-400 text-white text-[10px] font-bold px-3 py-1 rounded-br-lg shadow-sm z-10">
                                            #{index + 1}
                                        </div>

                                        <div className="flex items-start gap-4 mb-4 mt-2">
                                            <img
                                                src={`${config.API_BASE_URL}/${college.image}`}
                                                alt={college.collegeName}
                                                className="w-16 h-16 rounded-lg object-contain border border-gray-100 bg-white flex-shrink-0"
                                            />
                                            <div className="flex-1 min-w-0">
                                                <NavLink
                                                    to={`/college/${college._id}`}
                                                    className="font-bold text-gray-900 leading-tight text-lg block mb-1 hover:text-brand-orange no-underline"
                                                >
                                                    {college.collegeName}
                                                </NavLink>
                                                <p className="text-xs text-gray-500 mb-2 line-clamp-2">{college.subheading}</p>

                                                {/* Rating */}
                                                <div className="flex items-center gap-1 text-yellow-500 bg-yellow-50 w-fit px-2 py-0.5 rounded-md">
                                                    <FiStar className="fill-current" size={10} />
                                                    <span className="text-xs font-bold text-gray-700">#{college.singleRating || index + 3}</span>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Details Grid */}
                                        <div className="grid grid-cols-2 gap-4 border-t border-gray-50 pt-3 mb-4">
                                            <div>
                                                <p className="text-[10px] text-gray-400 uppercase font-bold">Fees</p>
                                                <p className="text-sm font-bold text-green-600">
                                                    ₹ {college.coursesDeatils && college.coursesDeatils[0]?.fees ? college.coursesDeatils[0].fees : "2.31 Lakhs"}
                                                </p>
                                                <p className="text-xs text-gray-500 mt-0.5">
                                                    {college.coursesDeatils && college.coursesDeatils[0]?.courses ? college.coursesDeatils[0].courses : "1st Year Fees"}
                                                </p>
                                            </div>
                                            <div>
                                                <p className="text-[10px] text-gray-400 uppercase font-bold">Deadline</p>
                                                <p className="text-xs font-bold text-gray-800 mb-1">
                                                    {college.coursesDeatils && college.coursesDeatils[0]?.applicationDate ? college.coursesDeatils[0].applicationDate : "10 June - 18 Jun 2024"}
                                                </p>
                                                <span className="text-[10px] font-bold text-green-600 bg-green-50 px-2 py-0.5 rounded-full uppercase">
                                                    Admissions Open
                                                </span>
                                            </div>
                                        </div>

                                        {/* Actions */}
                                        <div className="flex flex-col gap-2 mt-2">
                                            <button
                                                onClick={handleOpenPopup}
                                                className="w-full bg-brand-orange text-white text-sm font-bold py-3 rounded-lg hover:bg-orange-600 transition flex items-center justify-center gap-2 border-0 shadow-sm"
                                            >
                                                Apply Now <FiArrowRight size={14} />
                                            </button>
                                            <NavLink
                                                to={`/college/${college._id}`}
                                                className="w-full bg-white text-gray-700 border border-gray-200 text-sm font-bold py-3 rounded-lg hover:bg-gray-50 transition flex items-center justify-center no-underline"
                                            >
                                                View Details
                                            </NavLink>
                                        </div>
                                    </div>

                                    {/* Desktop Row View */}
                                    <div className="hidden md:grid grid-cols-12 gap-3 py-4 px-5 border-b border-gray-100 hover:bg-orange-50/30 transition items-center">
                                        <div className="col-span-1 flex justify-center">
                                            <div className="flex items-center justify-center w-8 h-8 rounded-full bg-gray-100 text-gray-600 font-bold text-xs">
                                                #{index + 1}
                                            </div>
                                        </div>

                                        <div className="col-span-5 flex items-center gap-3">
                                            <img
                                                src={`${config.API_BASE_URL}/${college.image}`}
                                                alt={college.collegeName}
                                                className="w-10 h-10 rounded-lg object-contain border border-gray-100 bg-white flex-shrink-0"
                                            />
                                            <div className="min-w-0">
                                                <NavLink
                                                    to={`/college/${college._id}`}
                                                    className="font-bold text-gray-800 hover:text-brand-orange transition text-sm block truncate no-underline"
                                                >
                                                    {college.collegeName}
                                                </NavLink>
                                                <p className="text-xs text-gray-500 mt-0.5 truncate">{college.subheading}</p>
                                                <button
                                                    onClick={handleOpenPopup}
                                                    className="mt-1 text-xs text-brand-orange font-bold hover:underline bg-transparent border-0 p-0 flex items-center gap-1"
                                                >
                                                    Apply Now <FiArrowRight size={10} />
                                                </button>
                                            </div>
                                        </div>

                                        <div className="col-span-2">
                                            <div className="flex items-center gap-1 text-yellow-500">
                                                <FiStar className="fill-current" size={12} />
                                                <span className="text-xs font-bold text-gray-700">#{college.singleRating || index + 3}</span>
                                            </div>
                                            <p className="text-[10px] text-gray-400">TOP 100 UNIV.</p>
                                        </div>

                                        <div className="col-span-2">
                                            <p className="text-xs font-semibold text-gray-700">
                                                {college.coursesDeatils && college.coursesDeatils[0]?.applicationDate
                                                    ? college.coursesDeatils[0].applicationDate
                                                    : "10 June - 18 Jun 2024"}
                                            </p>
                                            <p className="text-[10px] text-green-600 uppercase font-bold mt-0.5">
                                                Admissions Open
                                            </p>
                                        </div>

                                        <div className="col-span-2">
                                            <p className="text-sm font-bold text-green-600">
                                                ₹ {college.coursesDeatils && college.coursesDeatils[0]?.fees
                                                    ? college.coursesDeatils[0].fees
                                                    : "2.31 Lakhs"}
                                            </p>
                                            <p className="text-[10px] text-gray-400 mt-0.5">
                                                {college.coursesDeatils && college.coursesDeatils[0]?.courses ? college.coursesDeatils[0].courses : "1st Year Fees"}
                                            </p>
                                        </div>
                                    </div>
                                </React.Fragment>
                            ))
                        ) : (
                            <div className="p-8 text-center text-gray-500">Loading top colleges...</div>
                        )}
                    </div>

                    {/* Popup Modal */}
                    {showPopup && (
                        <div
                            className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-[999] p-4"
                            onClick={handleClosePopup}
                        >
                            <div
                                className="bg-white rounded-2xl w-full max-w-lg mx-4 relative max-h-[85vh] overflow-y-auto shadow-2xl custom-scrollbar"
                                onClick={(e) => e.stopPropagation()}
                            >
                                {/* Close Button */}
                                <button
                                    onClick={handleClosePopup}
                                    className="absolute top-4 right-4 z-10 bg-white/90 hover:bg-white text-gray-600 hover:text-gray-900 rounded-full p-2 shadow-lg transition-all duration-200 hover:scale-110"
                                    aria-label="Close"
                                >
                                    <svg className="w-6 h-6" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" stroke="currentColor">
                                        <path d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                </button>

                                {/* Form Content with Padding */}
                                <div className="p-0">
                                    <Popupform />
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
};

export default TopCollegesSection;
